import { IconBuildingBank } from '@tabler/icons';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { userRole } from '../store/actions/userActions';

const icons = { IconBuildingBank };

// ==============================|| ORGANIZATIONS MENU ITEMS ||============================== //

// const retrieveUserData = async () => {
//     try {
//         const res = await axios.get('/api/getUserDataFromSession');
//         console.log(res.data.response);
//         return res.data.response;
//     } catch (error) {
//         console.error(error.response.data);
//         return null;
//     }
// }
// const userData = await retrieveUserData();

const organizations = (userData) => ({
    id: 'organizations',
    // title: 'Organizacijos',
    type: 'group',
    children: [
        {
            id: 'allOrganizations',
            title: 'Klientai',
            type: 'collapse',
            icon: icons.IconBuildingBank,
            // children: userData && (userData.role === process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString() || userData.role === process.env.REACT_APP_SUPER_USER_TC_ID.toString()) ? [
            children: [
                {
                    id: 'allOrganizations-connections',
                    title: 'Institucijos',
                    type: 'item',
                    url: '/organizacijos/institucijos',
                },
                {
                    id: 'contracts',
                    title: 'Sutartys',
                    type: 'collapse',
                    children: [
                        {
                            id: 'signedContracts',
                            title: 'Pasirašytos sutartys',
                            type: 'item',
                            url: '/organizacijos/sutartys/pasirašytos'
                        },
                        {
                            id: 'needsSigning',
                            title: 'Formuojamos sutartys',
                            type: 'item',
                            url: '/organizacijos/sutartys/formuojamos'
                        }
                    ]
                    // type: 'item',
                    // url: '/organizacijos/sutartys',
                },
                {
                    id: 'organizations-contacts',
                    title: 'Kontaktai',
                    type: 'item',
                    url: '/organizacijos/kontaktai'
                },
                {
                    id: 'all-requests',
                    title: 'Užklausos',
                    type: 'item',
                    url: '/užklausos/visos'
                }
            ]
            // children: userData && (userData.TC === 'suser' || userData.TC === 'KTU') ? [
            //     {
            //         id: 'allOrganizations-connections',
            //         title: 'Institucijos',
            //         type: 'item',
            //         url: '/organizacijos/institucijos',
            //     },
            //     {
            //         id: 'organizations-reviewed',
            //         title: 'Sutartys',
            //         type: 'item',
            //         url: '/organizacijos/perziuretos',
            //     },
            //     {
            //         id: 'organizations-contacts',
            //         title: 'Kontaktai',
            //         type: 'item',
            //         url: '/organizacijos/kontaktai'
            //     }
            //     // {
            //     //     id: 'allOrganizations-contacts',
            //     //     title: 'Kontaktai',
            //     //     type: 'item',
            //     //     url: '/organizacijos/kontaktai',
            //     // }
            // ] : [
            //     {
            //         id: 'allOrganizations-connections',
            //         title: 'Institucijos',
            //         type: 'item',
            //         url: '/organizacijos/institucijos'
            //     }
            // ]
        }
    ]
})

export default organizations;